(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[11641],{

/***/ 77428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45559);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const ButtonArrow = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["button-arrow"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inner)
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ButtonArrow);


/***/ }),

/***/ 28946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ListingBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_svg_checkIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76798);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _buttonArrow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77428);
/* harmony import */ var _svg_starIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90303);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15614);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5__);






function ListingBlock({ item , index , state , category , type , handleModalClose  }) {
    const { 0: clicked , 1: setClicked  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const handleClick = ()=>{
        setClicked(true);
        if ((type === "listingModal" || type === "categoryListingModal") && handleModalClose) {
            handleModalClose();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["listing-block"])} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[type]}`,
        children: [
            type === "listingPage" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().order),
                children: index === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg_starIcon__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}) : index + 1
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: item.logoUrl,
                    alt: "logo"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "mb-4 font-bold lg:text-lg",
                        dangerouslySetInnerHTML: {
                            __html: item.title
                        }
                    }),
                    type !== "categoryListingModal" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().features),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "flex flex-col",
                            children: item.bulletedDescription?.map((feature, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    className: "text-sm font-light mb-2 flex items-start",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "children:h-3 children:w-3",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_checkIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "ml-2",
                                            dangerouslySetInnerHTML: {
                                                __html: feature
                                            }
                                        })
                                    ]
                                }, idx))
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().cta)} ${clicked ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().clicked) : ""}`,
                style: {
                    textAlign: "center"
                },
                children: [
                    item.revenue && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "mb-1 block",
                        children: [
                            "$",
                            item.revenue
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        target: "_blank",
                        onClick: handleClick,
                        href: `/${category?.slugAlias ?? ""}/offer/${item.slug}`,
                        rel: "noreferrer",
                        children: !clicked ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main),
                            children: [
                                "view deal",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttonArrow__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default().check),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_svg_checkIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                        })
                    }),
                    index === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["cta-state"]),
                        children: [
                            state,
                            " Best ",
                            category?.name
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 90303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StarIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function StarIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "517",
        height: "493",
        fill: "none",
        viewBox: "0 0 517 493",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            d: "M257.542.014a11.2 11.2 0 00-10.105 7.719l-56.223 168.68H11.164a11.2 11.2 0 00-6.613 20.21l146.25 106.94-56.223 174.56v.004a11.197 11.197 0 004.086 12.535 11.203 11.203 0 0013.184-.039l146.25-106.94 146.25 106.94a11.203 11.203 0 0013.184.039 11.196 11.196 0 004.086-12.535l-56.223-174.56 146.25-106.94v-.004a11.2 11.2 0 00-6.613-20.21h-180.05L268.759 7.733a11.2 11.2 0 00-11.207-7.72h-.01z",
            clipRule: "evenodd"
        })
    });
}


/***/ }),

/***/ 11641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ InsuranceSuperSaverWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/svg/callCenterIcon.tsx
var callCenterIcon = __webpack_require__(86106);
;// CONCATENATED MODULE: ./src/lib/insurancesupersaver/callUs.ts
const checkingWorkingHours = (overrideChecking)=>{
    if (overrideChecking) return true;
    const currentDate = new Date();
    const currentDayName = currentDate.toLocaleString("en-US", {
        weekday: "long"
    });
    const currentTime = currentDate.toLocaleTimeString("en-US", {
        timeZone: "EST",
        hour12: false
    });
    const currentHour = parseInt(currentTime.split(":")[0], 10);
    const currentMinute = parseInt(currentTime.split(":")[1], 10);
    const currentTimeInMinutes = currentHour * 60 + currentMinute;
    let startTime, endTime;
    switch(currentDayName){
        case "Monday":
        case "Tuesday":
        case "Wednesday":
        case "Thursday":
        case "Friday":
            startTime = "8:00";
            endTime = "17:00";
            break;
        default:
            return false;
    }
    const startHour = parseInt(startTime.split(":")[0], 10);
    const startMinute = parseInt(startTime.split(":")[1], 10);
    const startTimeInMinutes = startHour * 60 + startMinute;
    const endHour = parseInt(endTime.split(":")[0], 10);
    const endMinute = parseInt(endTime.split(":")[1], 10);
    const endTimeInMinutes = endHour * 60 + endMinute;
    if (startTimeInMinutes <= currentTimeInMinutes && currentTimeInMinutes <= endTimeInMinutes) {
        return true;
    } else {
        return false;
    }
};
const gettingPhoneNumber = (category)=>{
    const callCenterPhoneNumber = {
        label: "",
        value: ""
    };
    switch(category){
        case "life":
            callCenterPhoneNumber["label"] = "(844) 720-7786";
            callCenterPhoneNumber["value"] = "844-720-7786";
            return callCenterPhoneNumber;
        case "health":
            callCenterPhoneNumber["label"] = "(833) 447-1422";
            callCenterPhoneNumber["value"] = "833-447-1422";
            return callCenterPhoneNumber;
        case "medicare":
            callCenterPhoneNumber["label"] = "(833) 443-1562";
            callCenterPhoneNumber["value"] = "833-443-1562";
            return callCenterPhoneNumber;
        default:
            null;
    }
    return null;
};

// EXTERNAL MODULE: ./src/lib/shared/carChexWorkingHours.ts
var carChexWorkingHours = __webpack_require__(16001);
;// CONCATENATED MODULE: ./src/lib/insurancesupersaver/workingHours.ts
const workingHours = [
    {
        dayName: "Saturday",
        startTime: "8:00",
        endTime: "17:00",
        isOff: true
    },
    {
        dayName: "Sunday",
        startTime: "8:00",
        endTime: "17:00",
        isOff: true
    },
    {
        dayName: "Monday",
        startTime: "8:00",
        endTime: "17:00",
        isOff: false
    },
    {
        dayName: "Tuesday",
        startTime: "8:00",
        endTime: "17:00",
        isOff: false
    },
    {
        dayName: "Wednesday",
        startTime: "8:00",
        endTime: "17:00",
        isOff: false
    },
    {
        dayName: "Thursday",
        startTime: "8:00",
        endTime: "17:00",
        isOff: false
    },
    {
        dayName: "Friday",
        startTime: "8:00",
        endTime: "17:00",
        isOff: false
    }, 
];

// EXTERNAL MODULE: ./src/lib/shared/routerQueriesToString.ts
var routerQueriesToString = __webpack_require__(78418);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/insurancesupersaver/logo/index.tsx


function InsuranceSuperSaverLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "818",
        height: "283",
        fill: "none",
        viewBox: "0 0 818 283",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#79B4E2",
                d: "M517.3 46.3c-2.4-5.5-5.2-10.9-8.5-16-1.6-2.6-3.4-5.1-5.2-7.5-.9-1.2-1.9-2.4-2.9-3.6l-1.6-1.8c-.6-.6-1-1.1-1.9-1.9l-3.1-3.1-4 1.2c-.2.1-.8.2-1.3.3l-1.6.3c-1.1.2-2.2.4-3.3.5-2.2.3-4.5.6-6.7.8-4.5.4-9.1.6-13.8.6-9.3 0-18.6-.7-27.9-2-9.3-1.3-18.6-3-27.8-5.1-9.2-2.1-18.3-4.7-27.4-7.6L375.9 0l-1.5 4.2c-.2.7-.7 1.8-1.2 2.7-.5.9-1 1.9-1.5 2.8-1.1 1.9-2.2 3.7-3.4 5.6-2.4 3.7-5.2 7.1-8.2 10.4-6 6.6-12.9 12.5-20.3 17.7-7.4 5.3-15.3 9.8-23.6 13.7-8.3 4-16.9 7.3-25.7 10.1 9.1-1.8 18-4.3 26.8-7.4 8.7-3.2 17.3-7.1 25.4-11.9 8.1-4.8 15.8-10.5 22.7-17 3.4-3.3 6.7-6.8 9.7-10.6 1.5-1.9 2.9-3.9 4.2-6 .5-.8 1.1-1.7 1.6-2.6 7.9 3 15.8 5.7 23.9 8.1 9.4 2.8 18.9 5.1 28.6 6.8 9.7 1.7 19.5 2.9 29.5 3.4 5 .2 10 .2 15 0 2.5-.1 5.1-.3 7.6-.6 1.1-.1 2.2-.3 3.3-.4.8.9 1.5 1.9 2.2 2.9 1.5 2.1 2.9 4.3 4.3 6.6 2.7 4.5 5 9.3 7 14.2 3.5 8.5 6 17.5 7.6 26.7h16.8c-1.6-11.4-4.8-22.5-9.4-33.1z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#266199",
                d: "M485.4 209.8c-8.6 18.1-18.7 35.6-29.7 52.5-8.4-3.2-16.7-6.6-25-10.2-10.2-4.5-20.2-9.3-30.1-14.5-16.5-8.7-32.2-18.8-46.7-30.4h-17c.4.4.8.8 1.2 1.3 4.2 4 8.5 7.9 12.9 11.7 4.5 3.7 9 7.3 13.7 10.7 9.3 6.9 19 13.2 29 19 9.9 5.9 20.2 11.2 30.6 16.2 10.4 5 21 9.5 31.7 13.7l5.9 2.3 3.7-5.3c13.2-18.9 25.1-38.6 35.4-59.5 1.6-3.3 3.2-6.7 4.7-10h-19.1c-.4.8-.8 1.7-1.2 2.5zM199.4 221.2l-3.9 2.6c-1.2-2-3.1-3.3-5.9-3.3-3.1 0-5.5 1.5-5.5 3.9 0 1.8 2.2 3.2 7 4 6.7 1.2 9.2 3.8 9.2 8.3 0 5.5-4.4 8.7-11.1 8.7-5.2 0-8.4-1.6-10.8-5.2l3.7-2.9c2.3 2.8 4.3 3.7 7.1 3.7 3.5 0 6.1-1.7 6.1-4.3 0-2.6-1.7-3.6-7.8-4.9-5.5-1.2-7.9-3.4-7.9-7.6 0-5.1 4.7-8.2 10.4-8.2 4.2.1 7.7 1.9 9.4 5.2zM211.4 233.7c0 4.2 1.9 7.4 6.4 7.4 5.8 0 8.6-4.2 8.6-10.5v-13.8h4.6v21.6c0 1.7.2 4.7.2 6.2h-4.3c0-2-.1-2.7-.1-4.6h-.1c-1.4 3.1-5.1 5.3-9.3 5.3-6.9 0-10.5-4.4-10.5-11.1v-17.4h4.6v16.9h-.1zM269 230.8c0 8.3-6.1 14.6-13.9 14.6-4.7 0-8.9-2.3-10.7-5.6h-.1v18.5h-4.6v-41.4h4.6v4h.1c2.6-3 5.9-4.8 10-4.8 8.7 0 14.6 6.2 14.6 14.7zm-14.9 10.3c5.9 0 9.9-4.5 9.9-10.3 0-5.9-3.9-10.3-9.9-10.3-5.8 0-9.8 4.5-9.8 10.3-.1 6 4 10.3 9.8 10.3zM302.1 231.1v1.1h-22.5c.5 5.2 4.3 8.9 9.2 8.9 3.9 0 6.6-1.4 8.8-4.2l3.5 2.7c-2.9 3.8-6.7 5.8-12.3 5.8-8.6 0-14.2-6.3-14.2-14.6 0-8.6 6-14.6 14.3-14.6 7.2-.1 13.2 4.5 13.2 14.9zm-13.5-10.7c-4.8 0-8.3 2.8-9 7.9h17.5c-.3-4.8-3.3-7.9-8.5-7.9zM324.8 216.4l-.3 4.7c-.9-.2-1.6-.4-2.5-.4-5.4 0-8.1 3.7-8.1 10.1v13.8h-4.6V223c0-1.8-.2-4.5-.2-6.2h4.4c0 1.7.1 2.7.1 4.6h.1c1.5-3.2 5.2-5.3 9.3-5.3.6 0 1.2.1 1.8.3zM546.6 221.2l-3.9 2.6c-1.2-2-3.1-3.3-5.9-3.3-3.1 0-5.5 1.5-5.5 3.9 0 1.8 2.2 3.2 7 4 6.7 1.2 9.2 3.8 9.2 8.3 0 5.5-4.4 8.7-11.1 8.7-5.2 0-8.4-1.6-10.8-5.2l3.7-2.9c2.3 2.8 4.3 3.7 7.1 3.7 3.5 0 6.1-1.7 6.1-4.3 0-2.6-1.7-3.6-7.8-4.9-5.5-1.2-7.9-3.4-7.9-7.6 0-5.1 4.7-8.2 10.4-8.2 4.2.1 7.6 1.9 9.4 5.2zM576.3 227.6v12.5c0 1 .1 2.7.4 4.6h-4.5c-.2-.7-.3-1.8-.3-4.2h-.1c-2.1 3.2-5.3 4.9-9.2 4.9-6.1 0-10.3-3.2-10.3-8.3 0-6.4 4.8-9.8 17.2-9.8h2.1v-.8c0-4.1-2.6-6.2-6.9-6.2-3 0-6.1 1-8.3 3l-2.9-3c2.9-2.9 7-4.3 11.1-4.3 8.1.1 11.7 4 11.7 11.6zm-12.9 13.9c4.8 0 8.2-3.2 8.2-9.1v-1.1h-5.1c-5.5 0-9.2 1.7-9.2 5.4 0 3.1 2.2 4.8 6.1 4.8zM595.1 238.7h.1l8.3-21.8h5l-11 27.8h-5.1L581 216.9h5.4l8.7 21.8zM639.3 231.1v1.1h-22.4c.5 5.2 4.3 8.9 9.2 8.9 3.9 0 6.6-1.4 8.8-4.2l3.5 2.7c-2.9 3.8-6.7 5.8-12.3 5.8-8.6 0-14.2-6.3-14.2-14.6 0-8.6 6-14.6 14.3-14.6 7.2-.1 13.1 4.5 13.1 14.9zm-13.4-10.7c-4.8 0-8.3 2.8-9 7.9h17.5c-.3-4.8-3.3-7.9-8.5-7.9zM662.1 216.4l-.3 4.7c-.9-.2-1.6-.4-2.5-.4-5.4 0-8.1 3.7-8.1 10.1v13.8h-4.6V223c0-1.8-.2-4.5-.2-6.2h4.4c0 1.7.1 2.7.1 4.6h.1c1.5-3.2 5.2-5.3 9.3-5.3.6 0 1.2.1 1.8.3z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#184070",
                d: "M19.1 195.2H0V87.4h19.2v107.8h-.1zM114.3 167.5h.3V87.4h19.2v107.8h-24.4l-53.3-82.7h-.3v82.7H36.6V87.4H62l52.3 80.1zM218.6 95.8l-14 14.8c-4.3-5.9-11.4-8.5-18.9-8.5-10.8 0-17.7 5.5-17.7 13.9 0 7.3 6.1 11.3 16.7 14.6 17.2 5.3 34.4 10.8 34.4 33S201.6 198 180.4 198c-15.2 0-27.7-4.6-36.1-14.6l14.5-14c4.7 7.2 12.6 11.3 21.3 11.3 10.4 0 18.9-6.1 18.9-14.8 0-8.1-5.5-12.3-19.3-16.6-19.3-5.9-31.8-12.5-31.8-32s16.3-32.6 39.7-32.6c12.4 0 23.3 3.9 31 11.1zM251.7 87.4v68c0 9.9 5.6 24.2 24.2 24.2s24.2-14.3 24.2-24.2v-68h19.2v69c0 21.2-14.9 41.6-43.4 41.6-28.6 0-43.4-20.6-43.4-41.6v-69h19.2zM374.9 87.4c20.7 0 39.6 7.3 39.6 30.9 0 16.1-9.7 27.1-25 29.2l28.6 47.6H395l-25-45.7h-14v45.7h-19.2V87.4h38.1zm-3.1 45.7c11 0 22.5-1.5 22.5-14.9 0-12.3-11.1-14.3-21.2-14.3h-17.2v29.2h15.9z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#184070",
                d: "M524.5 195.2h-21.9l-10-24.7h-46.7l-9.7 24.7h-21.5l46.9-107.8h16.6l46.3 107.8zm-38.7-41.1l-16.6-43.8-16.9 43.8h33.5zM608.1 167.5h.3V87.4h19.2v107.8h-24.4l-53.3-82.7h-.3v82.7h-19.2V87.4h25.5l52.2 80.1zM734.4 101.7l-14.9 11c-6.2-6.7-13.2-10.7-22.7-10.7-22.1 0-37 17.1-37 38.5 0 22.2 14.3 40 37 40 10.2 0 18.1-5.3 24.2-13.1l15.8 11.3c-9.3 13.1-24.4 19.2-40.2 19.2-33.2 0-56.9-22.7-56.9-56.2s22.5-57.1 56.9-57.1c15.4.1 27.6 5.6 37.8 17.1zM815.1 104.8h-52.2v26.5h49.5v17.4h-49.5v29.2h55v17.4h-74.1V87.4h71.4v17.4h-.1z"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/insurancesupersaver/header/styles.module.scss
var styles_module = __webpack_require__(88198);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/styles/variables/insurancesupersaverVariables.module.scss
var insurancesupersaverVariables_module = __webpack_require__(25192);
var insurancesupersaverVariables_module_default = /*#__PURE__*/__webpack_require__.n(insurancesupersaverVariables_module);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/insurancesupersaver/header/index.tsx












function Header({ headerMessage  }) {
    const router = (0,next_router.useRouter)();
    const { category , domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const isWorkingHours = (0,carChexWorkingHours/* checkingWorkingHours */.H)(router.query.callUs === "true", workingHours);
    const handleMenuItemClick = (url)=>{
        const zipCode = localStorage.getItem("filters") ? JSON.parse(localStorage.getItem("filters")).zipCode : null;
        if (zipCode) {
            if (zipCode.length >= 4) {
                const formattedZipCode = zipCode.length === 4 ? `0${zipCode}` : zipCode;
                window.location.href = `${window.location.origin}/${url}/offers?zc=${formattedZipCode}&referrer=${url ?? "home"}&${(0,routerQueriesToString/* gettingQueriesAsString */.r)(router.query, "inline")}`;
            } else {
                window.location.href = `/${url}`;
            }
        } else {
            window.location.href = `/${url}`;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: (styles_module_default()).header,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "inner max-w-7xl mx-auto px-4 py-4 flex justify-between items-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "md:pd-x0 flex justify-between items-center w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "/",
                            "aria-label": "insurancesupersaver logo",
                            children: domain?.logo?.fullPath ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: domain.logo.fullPath,
                                className: "w-20 h-auto lg:w-32",
                                alt: "insurancesupersaver logo"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "children:w-20 children:h-7 lg:children:w-32 lg:children:h-11",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceSuperSaverLogo, {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: isWorkingHours && router.query?.category && gettingPhoneNumber(router.query?.category) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "flex items-center",
                                href: `tel:${gettingPhoneNumber(router.query?.category)?.value ?? ""}`,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(callCenterIcon/* default */.Z, {
                                        className: "w-7 h-7 lg:w-9 lg:h-9 mr-2 hidden md:inline",
                                        fill: (insurancesupersaverVariables_module_default()).assault
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: (insurancesupersaverVariables_module_default()).assault
                                        },
                                        className: "text-sm lg:text-lg font-bold",
                                        children: gettingPhoneNumber(router.query?.category)?.label
                                    })
                                ]
                            })
                        }) : headerMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).state,
                            children: headerMessage
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "flex items-center",
                                children: domain.categories?.map((categoryItem, index)=>{
                                    if (categoryItem.slug !== category?.slug) return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "mx-2 lg:mx-4 font-light text-xs lg:text-sm",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "cursor-pointer capitalize",
                                            onClick: ()=>handleMenuItemClick(categoryItem.slugAlias),
                                            children: categoryItem.slugAlias
                                        })
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
// EXTERNAL MODULE: ./src/components/insurancesupersaver/listingBlock/index.tsx
var listingBlock = __webpack_require__(28946);
;// CONCATENATED MODULE: ./src/components/layouts/insuranceSuperSaverWrapper.tsx











const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 31701).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 18740).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
function InsuranceSuperSaverWrapper({ headerMessage , page , children  }) {
    const { modal , setModal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { category , clicksOffers: offers , zipCodeLocation , visitDetails ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const { active: modalActive , content: modalContent  } = modal;
    const state = zipCodeLocation ? zipCodeLocation.city : visitDetails?.region;
    const handleClose = ()=>{
        closeModal();
    };
    (0,react.useEffect)(()=>{
        if (page === "categoryPage" && (visitDetails?.trafficSourceType === "Social Media" || visitDetails?.trafficSourceNetwork === "Propel Media")) {
            window.setTimeout(()=>{
                if (offers?.length) {
                    timerMouseLeave();
                }
            }, 3000);
        }
    }, [
        visitDetails
    ]);
    const timerMouseLeave = ()=>{
        handleModalCookie(`${category?.slugAlias ?? ""}-category-page-modal-shown`);
    };
    const handleMouseLeave = ()=>{
        if (document.activeElement?.tagName === "INPUT" || document.activeElement?.tagName === "SELECT" || page === "homePage" || !offers?.length || visitDetails?.trafficSourceType !== "Social Media" && visitDetails?.trafficSourceNetwork !== "Propel Media") return;
        let cookieText = "-modal-shown";
        if (page === "categoryPage") {
            cookieText = "-category-page-modal-shown";
        }
        handleModalCookie(`${category?.slugAlias ?? ""}${cookieText}`);
    };
    const handleModalCookie = (cookieName)=>{
        if (!(0,lib.getCookie)(cookieName) || parseInt((0,lib.getCookie)(cookieName), 10) < 2) {
            setModal({
                active: true,
                content: page
            });
            (0,lib.setCookie)(cookieName, (0,lib.getCookie)(cookieName) ? parseInt((0,lib.getCookie)(cookieName), 10) + 1 : 1);
        }
    };
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {});
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {});
            case "listingPage":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            style: {
                                color: (insurancesupersaverVariables_module_default()).assault
                            },
                            className: "font-bold text-xl mb-4 lg:px-4",
                            children: [
                                "Check ",
                                state,
                                " Top ",
                                category?.name,
                                " Company"
                            ]
                        }),
                        offers && offers[0] && /*#__PURE__*/ (0,jsx_runtime.jsx)(listingBlock/* default */.Z, {
                            item: offers[0],
                            state: state,
                            category: category ?? null,
                            type: "listingModal",
                            handleModalClose: handleClose,
                            index: 0
                        })
                    ]
                });
            case "categoryPage":
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            style: {
                                color: (insurancesupersaverVariables_module_default()).assault
                            },
                            className: "font-bold text-xl mb-4 lg:px-4",
                            children: [
                                "Check ",
                                state,
                                " Top ",
                                category?.name,
                                " Companies"
                            ]
                        }),
                        offers?.slice(0, 2).map((offer, index)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(listingBlock/* default */.Z, {
                                item: offer,
                                state: state,
                                category: category ?? null,
                                type: "categoryListingModal",
                                handleModalClose: handleClose,
                                index: index
                            }, index);
                        })
                    ]
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                onMouseLeave: handleMouseLeave,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        headerMessage: headerMessage
                    }),
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        textColor: (insurancesupersaverVariables_module_default()).blueAster
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: modalContent === "listingPage" || modalContent === "categoryPage" ? {
                            display: "flex",
                            flexDirection: "column",
                            padding: "30px 20px",
                            paddingBottom: "5px",
                            fontFamily: `'Poppins', sans-serif`,
                            borderRadius: "10px"
                        } : {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: modalContent === "listingPage" || modalContent === "categoryPage" ? undefined : "h-[90vh] rounded",
                        bodyStyles: modalContent === "listingPage" || modalContent === "categoryPage" ? undefined : {
                            overflowY: "scroll"
                        },
                        width: modalContent === "listingPage" || modalContent === "categoryPage" ? 500 : 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 86106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CallCenterIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CallCenterIcon({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        fill: "none",
        viewBox: "0 0 100 100",
        className: className ?? "",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: fill ?? "#000",
            fillRule: "evenodd",
            d: "M55.593 93.297a7.215 7.215 0 01-7.104 5.89c-3.988 0-7.221-3.22-7.221-7.19 0-3.972 3.233-7.19 7.221-7.19a7.225 7.225 0 016.423 3.898c19.102-2.683 29.983-11.136 32.641-25.357-1.133.603-2.692-.386-4.677-2.968 0 0-7.57 17.754-19.538 20.67 17.51-14.738 5.792-37.794 3.174-42.574-2.618-4.78-3.624-6.694-4.849.999-2.84 12.297-30.994 5.092-35.061 16.062-2.712 7.314.604 16.086 9.948 26.316-10.126-3.079-17.001-9.73-20.624-19.952C11.485 68.329 3.16 63.274 3 59.26V40.364c.004-3.38 1.985-5.488 5.942-6.322 8.587-42.238 69.546-45.8 80.114-1.489 4.971 0 7.62 1.975 7.944 5.923l-.426 18.425c.048 2.922-1.37 5.071-4.253 6.447-3.84 16.7-16.082 26.683-36.728 29.95zm-39.41-56.535C23.38 20.998 34.653 13.43 50 14.057c21.029.774 30.198 15.997 32.166 22.705l.91-.899C77.693 16.976 66.411 7.533 49.23 7.533c-17.181 0-28.464 9.443-33.847 28.33l.8.9z",
            clipRule: "evenodd"
        })
    });
}


/***/ }),

/***/ 76798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CheckIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CheckIcon({ className , fill  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0",
        y: "0",
        enableBackground: "new 0 0 32 26",
        version: "1.1",
        viewBox: "0 0 32 26",
        xmlSpace: "preserve",
        className: className ?? "",
        fill: fill,
        style: {
            fill: fill
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M27.1 0L25 2.2 10.7 17.4l-4.3-4.3L4.2 11 0 15.2l2.1 2.1 6.5 6.5 2.2 2.2 2.1-2.2L29.4 6.3l2.1-2.2L27.1 0z"
        })
    });
}


/***/ }),

/***/ 16001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ checkingWorkingHours; }
/* harmony export */ });
/* unused harmony export checkingCarChexWorkingDays */
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75094);

const getWorkingHours = (currentDayName, workingDays)=>{
    const workingDaysObject = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .arrayToKeyedObject */ .sB)(workingDays, "dayName");
    return workingDaysObject[currentDayName];
};
const checkingWorkingHours = (overrideChecking, workingDays)=>{
    if (overrideChecking) return true;
    const ESTOffset = 3600000 * -5;
    const currentDate = Date.parse(new Date().toString());
    const currentETSDate = new Date(currentDate + ESTOffset);
    const currentDayName = currentETSDate.toLocaleString("en-US", {
        weekday: "long"
    }).replace(/[^ -~]/g, "");
    const currentTime = currentETSDate.toLocaleTimeString("en-US", {
        timeZone: "UTC",
        hour12: false
    });
    const splittedCurrentTime = currentTime.replace(/[^ -~]/g, "").split(":");
    const currentHour = parseInt(splittedCurrentTime[0], 10);
    const currentMinute = parseInt(splittedCurrentTime[1], 10);
    const currentTimeInMinutes = currentHour * 60 + currentMinute;
    const day = getWorkingHours(currentDayName, workingDays);
    if (day.isOff) return false;
    const startTime = day.startTime, endTime = day.endTime;
    const startHour = parseInt(startTime.split(":")[0], 10);
    const startMinute = parseInt(startTime.split(":")[1], 10);
    const startTimeInMinutes = startHour * 60 + startMinute;
    const endHour = parseInt(endTime.split(":")[0], 10);
    const endMinute = parseInt(endTime.split(":")[1], 10);
    const endTimeInMinutes = endHour * 60 + endMinute;
    if (startTimeInMinutes <= currentTimeInMinutes && currentTimeInMinutes <= endTimeInMinutes) {
        return true;
    } else {
        return false;
    }
};
const checkingCarChexWorkingDays = (overrideChecking, workingDays)=>{
    if (overrideChecking) return true;
    const ESTOffset = 3600000 * -5;
    const currentDate = Date.parse(new Date().toString());
    const currentETSDate = new Date(currentDate + ESTOffset);
    const currentDayName = currentETSDate.toLocaleString("en-US", {
        weekday: "long"
    }).replace(/[^ -~]/g, "");
    const currentTime = currentETSDate.toLocaleTimeString("en-US", {
        timeZone: "UTC",
        hour12: false
    });
    const splittedCurrentTime = currentTime.replace(/[^ -~]/g, "").split(":");
    const currentHour = parseInt(splittedCurrentTime[0], 10);
    const currentMinute = parseInt(splittedCurrentTime[1], 10);
    const currentTimeInMinutes = currentHour * 60 + currentMinute;
    const day = getWorkingHours(currentDayName, workingDays);
    if (day.isOff) return false;
    const startTime = day.startTime, endTime = day.endTime;
    const startHour = parseInt(startTime.split(":")[0], 10);
    const startMinute = parseInt(startTime.split(":")[1], 10);
    const startTimeInMinutes = startHour * 60 + startMinute;
    const endHour = parseInt(endTime.split(":")[0], 10);
    const endMinute = parseInt(endTime.split(":")[1], 10);
    const endTimeInMinutes = endHour * 60 + endMinute;
    if (startTimeInMinutes <= currentTimeInMinutes && currentTimeInMinutes <= endTimeInMinutes) {
        return true;
    } else {
        return false;
    }
};


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 45559:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button-arrow":"styles_button-arrow__q3ip1","inner":"styles_inner__LUme_","expand":"styles_expand__zRPmD"};

/***/ }),

/***/ 88198:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","header":"styles_header__ZMwlZ","state":"styles_state__aRMGB"};

/***/ }),

/***/ 15614:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","listing-block":"styles_listing-block__6HDft","order":"styles_order__tFuib","logo":"styles_logo__urjoU","content":"styles_content__hourn","features":"styles_features__3N8EZ","cta":"styles_cta__My40Z","check":"styles_check__kX7BM","cta-state":"styles_cta-state__F9scx","clicked":"styles_clicked__QW_F7","listingModal":"styles_listingModal__q_17W","categoryListingModal":"styles_categoryListingModal__j34IZ","blink":"styles_blink__e3fdp"};

/***/ }),

/***/ 25192:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa"};

/***/ })

}]);